var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeTabletGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 22.5H18.75C19.1477 22.4995 19.5289 22.3413 19.8101 22.0601C20.0913 21.7789 20.2495 21.3977 20.25 21V3C20.2495 2.60232 20.0914 2.22105 19.8102 1.93984C19.529 1.65864 19.1477 1.50046 18.75 1.5H5.25C4.8523 1.5004 4.471 1.65856 4.18978 1.93978C3.90856 2.221 3.7504 2.6023 3.75 3V21C3.75046 21.3977 3.90864 21.7789 4.18984 22.0602C4.47105 22.3414 4.85232 22.4995 5.25 22.5ZM5.25 21V3H18.75V21H5.25ZM14.25 18V19.5H9.75V18H14.25Z",
    fill: "#171719"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTabletGray);
export default __webpack_public_path__ + "static/media/home-tablet_gray.d3d656946598b95608bbc0c23691c3ce.svg";
export { ForwardRef as ReactComponent };